import { Fragment } from 'react';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { Box, Button, Stack } from '@src/components';

function getMonthLabels(locale = navigator.language) {
  const base = new Date(2020, 0, 1);
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(base.getFullYear(), i, 1);
    const label = new Intl.DateTimeFormat(locale, { month: 'short' }).format(d);
    return { label, idx: i };
  });
}

export default function MonthListSwitcher({ currentDates, onPrev, onNext, onGotoMonth, onGotoHalfMonth}) {
  const year = currentDates.start.getFullYear();
  const activeMonth = currentDates.start.getMonth();
  const startDate = currentDates.start.getDate();
  const months = getMonthLabels();

  return (
    <Box
      sx={StyleSheet.container}
    >
      <Button
        sx={StyleSheet.control}
        onClick={onPrev}
        startIcon={<ArrowBackIosNewIcon fontSize="small" />}
      />

      <Stack spacing={1}sx={StyleSheet.monthContainer} direction="row" justifyContent="space-between">
        {months.map((m, i) => {
          const isMonthActive = m.idx === activeMonth && startDate === 1;
          const isSeparatorActive = m.idx === activeMonth && startDate === 15;
          return (
            <Fragment key={i}>
              <Button
                key={m.idx}
                sx={StyleSheet.month(isMonthActive)}
                onClick={() => onGotoMonth(year, m.idx)}
              >
                {m.label}
              </Button>

              {i < months.length - 1 && (
                <Button
                  key={`separator-${i}`}
                  sx={StyleSheet.separator(isSeparatorActive)}
                  onClick={() => onGotoHalfMonth(year, m.idx)}
                >
                  •
                </Button>
              )}
            </Fragment>
          );
        })}
      </Stack>


      <Button
        sx={StyleSheet.control}
        onClick={onNext}
        endIcon={<ArrowForwardIosIcon fontSize="small" />}
      />
    </Box>
  );
}

const StyleSheet = {
  container: (theme) => ({
    background: theme.palette.grey[600],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
  }),
  control: (theme) => ({
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      fill: theme.palette.common.white,
    },
    padding: 0,
    minWidth: '20px',
  }),
  separator: (isActive) => (theme) => ({
    fontSize: '36px',
    padding: 0,
    minWidth: '10px',
    margin: 0,
    color: isActive ? theme.palette.common.white : theme.palette.grey[300],
  }),
  monthContainer: {
    width: '100%',
  },
  month: (isActive) => (theme) => ({
    color: isActive ? theme.palette.common.white : theme.palette.grey[300],
    fontSize: isActive ? '16px' : '14px',
    fontWeight: isActive ? 900 : 600,
    minWidth: '30px',
    padding: 0,
  }),
};
